import { compact } from '@direct-frontend/stdlib';
import { i18n } from './validateNotEmpty.i18n';

/**
 * Функция валидации фильтра на пустоту
 * @param values значения фильтра
 * @returns список ошибок
 * @kind helper
 */
export function validateNotEmpty(values: string[]) {
    const isEmpty = compact(values).length === 0;
    if (isEmpty) {
        return {
            errors: [i18n('Необходимо указать значение')],
        };
    }
    return null;
}
